import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './index.css';
import { testable } from '@xingternal/malt-util';
import { QA_MALT } from '@xingternal/malt-constants';

/** Any other props next to the defined ones can be passed onto the SVG that is rendered here. */

const LoadingSpinner = ({
  className = undefined,
  loaded = undefined,
  size = undefined,
  testId = undefined,
  ...props
}) => {
  if (loaded) {
    return null;
  }

  const TestableSvg = testable(QA_MALT, 'svg');

  return (
    <TestableSvg
      className={classnames(styles.spinner, className)}
      testId={testId}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 200 221"
      // eslint-disable-next-line react/prop-types
      style={{ fontSize: size, ...props.style }}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M113.33 217.45c-8.258999 4.723504-18.4010008 4.723504-26.66 0l-73.34-42.01C5.0986646 170.742551.0125777 161.997381 0 152.52V68.48c0-9.45 5.08-18.19 13.33-22.92L86.67 3.54c8.2589992-4.7235037 18.401001-4.7235037 26.66 0l73.34 42.02c8.231335 4.6974491 13.317422 13.4426189 13.33 22.92v84.04c0 9.45-5.08 18.19-13.33 22.92l-73.34 42.01z"
      />
    </TestableSvg>
  );
};

LoadingSpinner.displayName = 'LoadingSpinner';
LoadingSpinner.propTypes = {
  /** add a custom className to the component */
  className: PropTypes.string,
  /** define the outer bounds of the loading spinner square – defaults to containers font-size. Needs to be defined including the unit, e.g. 32px in order to be safely and correctly passed to the element's style attribute */
  size: PropTypes.string,
  /** returns `null` if true */
  loaded: PropTypes.bool,
  /** define styles to be applied to this component */
  style: PropTypes.object,
  /** define a testid for the spinner */
  testId: PropTypes.string,
};

export default LoadingSpinner;
